<template>
  <div class="c-profile-workspace">
    <div class="c-profile-workspace__details">
      <Workspace></Workspace>
    </div>
  </div>
</template>

<script>
import Workspace from "@swipekit/components/workspace";

export default {
  components: {
    Workspace,
  },
};
</script>

<style lang="scss">
.c-profile-workspace {
}
</style>
